const getServicoFilterFields = () => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'codigo',
    label: 'Código',
  },
  {
    name: 'item',
    label: 'Item',
  },
  {
    name: 'subitem',
    label: 'Subitem',
  },
  {
    name: 'desdobro',
    label: 'Desdobro',
  },
  {
    name: 'descricao',
    label: 'Descrição',
    initial: true,
  },
];

export default getServicoFilterFields;
